import styled from 'styled-components';
import SearchDropdownButton from '@/components/SearchDropdownButton';
import { Job } from '@/types/api';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: calc(100% - 300px);
  }
`;

export const FullWidth = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  margin-left: -20px;
  margin-right: -20px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding-left: 100px;
    padding-right: 100px;
    margin-left: -100px;
    margin-right: -100px;
  }
`;

export const PageGrid = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    flex-direction: row;
  }
`;

export const AssociateToJob = styled(SearchDropdownButton<Job>)`
  max-width: ${({ showInput }) => (showInput ? '496' : '150')}px;
  transition: max-width 0.3s ease-out;
  flex-grow: 1;
`;
